module.exports = __webpack_public_path__ + "img/4.381e7a47.svg";